<template>
  <div class="record-wrapper" @click="$emit('click')">
    <img :src="thumbnail" class="preview-container" />
    <div style="margin: 12px 8px">
      <div class="record-name single-line-text">{{ title }}</div>
      <div class="record-date">{{ studyDate }}</div>
      <div class="record-date">{{ provider }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DicomStudyCard',
  props: {
    thumbnail: {
      type: String
    },
    title: {
      type: String
    },
    studyDate: {
      type: String
    },
    provider: {
      type: String,
      default: ''
    }
  }
}
</script>

<style />
